import { MonitoringBackEndDataSourceModel } from '../../Shared/models/monitoring-back-end-data-source.model';
import { BriefingSortByEnum } from '../enums/briefing-sort-by.enum';
import { BriefingOrganizeByEnum } from '../enums/briefing-organize-by.enum';

export class BriefingQuickModel {
    name: string;
    dataSourceModel: MonitoringBackEndDataSourceModel;
    sortBy: BriefingSortByEnum;
    numberOfMentions?: number;
    organizeBy?: BriefingOrganizeByEnum;
    tagIds?: number[];
}
